import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { logi } from '@shared/utils/utils_logs';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__generation } from './STATE__generation';

export const LOCAL__generation_set_current = (payload: string): PayloadAction<string> => ({
  type: ENUM__redux_action.GENERATION_SET_CURRENT,
  payload: payload,
});

export function INIT_LOCAL__generation_set_current(state: STATE__generation, action: PayloadAction<string>) {
  let generation_id = action.payload;

  if (generation_id == state.generation_current._id) return;

  let generation = generation_id ? state.generations_map.get_or_assert(generation_id) : DTO__generation.CREATE_STUB();

  state.generation_current = new DTO__generation().clone(generation);
  logi(`🆙 generation_current\t${generation_id}`);

  let user_task_current = generation.is_stub() ? DTO__user_task.CREATE_STUB() : state.user_tasks_map.get_or_assert(generation.user_task_id);

  state.user_task_current = user_task_current;
}
